import { romeApi, utils } from "framework"

import storeEmployerBroker from "./x-employer-broker";
import storeEmployerSpecialists from './x-employer-specialists';
import storeEmployerParticipants from './x-employer-participants';
import storeEmployerCobraParticipants from './x-employer-cobra-participants';
import storeEmployerContacts from './x-employer-contacts';
import storeEmployerContracts from './x-employer-contracts';
import storeEmployerEnrollment from './x-employer-enrollment';
import storeEmployerOprs from './x-employer-oprs';
import storeAbTests from '../ab-testing/x-ab-tests';
import storeEmployerCobra from "./x-employer-cobra";

const initialState = {
    employerId: null,
    federalTaxId: null,
    name: null,
    legalName: null,
    address1: null,
    address2: null,
    city: null,
    state: null,
    zip: null,
    phone: null,
    amfCode: null,
    totalBenefitEligibleEmployees: null,
    employeesCount: null,
    legalEntityTypeId: null,
    legalConstructionState: null,
    cardProcessor: null,
    mainFax: null,
    strategicPartner: null,
    isTerminated: null,
    terminatedOn: null,
    substantiationType: null,
    noSubstantiationStart: null,
    substantiationNotes: null,
    paysFirst: null,
    hasCobra: null,
    cobraOnly: null,
    requiresFundingOption: null,
    isEdiClient: null,
    isCobraEdi: null,
    integratorId: null,
    hasProcessedEdiFiles: null,
    isMyPlanConnectEnabled: null,
    myPlanConnectEffectiveDate: null,
    ready: false,
    canAccessSelfService: null,
    firstDataPrin: null,
    notUsingSSN: null,
    hasParticipants: false,
    hasPlans: false,
    calendarRequired: null,
    terminationWorkflows: null,
    terminationWorkflowId: null,
    autoSubstantiationLimit: null,
    suspendCardOnNonSubstantiation: null,
    noCopaysApplicable: null,
    numberOfActiveParticipants: 0,
    hasEnrollablePlans: false,
    isHsaBin: false,
    cardsDisabled: false,
    cardsDisabledReason: null,
    terminationId: null,
    usesOurCobra: false
};

const state = Object.assign({}, initialState);

const modules = {
    broker: storeEmployerBroker,
    specialists: storeEmployerSpecialists,
    participants: storeEmployerParticipants,
    cobraParticipants: storeEmployerCobraParticipants,
    contacts: storeEmployerContacts,
    contracts: storeEmployerContracts,
    enrollment: storeEmployerEnrollment,
    oprs: storeEmployerOprs,
    abTesting: storeAbTests,
    cobra: storeEmployerCobra
};

const getters = {
  isWca(state) { return state.cardProcessor == 1 },
  isFirstData(state) { return state.cardProcessor == 2 },
  isEdiVisible(state) { return state.isEdiClient || state.hasProcessedEdiFiles },
  showEnrollmentEditor(state) {
    return state.cardProcessor == 2 && state.numberOfActiveParticipants <= 500 && state.hasEnrollablePlans;
  },
  abTests(state) {
    return state.abTesting.abTests.filter(t => t.entityId == state.employerId);
  }
};

const actions = {
    async load(context, data) {
        context.commit("setEmployerReady", false);
        let id = data.employerId;
        if(!id) return;
        if (!data.refreshSameEmployer && context.state.employerId == id) {
            context.commit("setEmployerReady", true);
            return;
        }

        let [employer, services, edi] = await Promise.all([
            romeApi.get(`/employer/${id}`),
            romeApi.get(`employer/${id}/services`),
            romeApi.get(`/employer/${id}/edi`)
        ]);
        context.commit('setEmployer', { ...employer, ...edi, ...services });
        context.commit("setEmployerReady", true);
    },
    clearEmployer(context) {
      context.commit('resetEmployer');
    },
    setEdi({ commit, state }, data) {
      commit("setEmployer", data);
    },
    setCobraOnly({commit}, isCobraOnly){
      commit("setEmployer", {cobraOnly: isCobraOnly});
    },

    async update({ commit, state }, data) {
        let id = state.employerId;
        if (!id) return;
        let postData = _.omit(state, "ready");
        _.assign(postData, data);
        await romeApi.post(`/employer/${id}/demographics`, postData);
        commit("setEmployer", data);
    },

    async updateEmployerSelfService({ commit }, data) {
        await romeApi.post(`employer/${data.employerId}/selfService?status=${data.status}`);
        commit("setEmployer", { canAccessSelfService: data.status });
    },

    async updateEmployerNoCopaysApplicable({ commit }, data) {
      await romeApi.post(`employer/${data.employerId}/noCopaysApplicable?status=${data.status}`);
      commit("setEmployer", { noCopaysApplicable: data.status });
  },
};

const mutations = {
  setEmployer(state, data) {
    utils.copyCommonProperties(data, state);
  },
  resetEmployer(state) {
    utils.copyCommonProperties(initialState, state);
  },
  setEmployerReady(state, value) {
    state.ready = value;
  }
};

export default {
  namespaced: true,
  state,
  modules,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/employer/x-employer.js